var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreHoriz24Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "more_horiz-24px",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#014171}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20353",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20354",
    d: "M6 10a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm12 0a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm-6 0a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2z",
    className: "cls-2",
    transform: "translate(0 -6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20355",
    d: "M6 10a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm12 0a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm-6 0a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2z",
    className: "cls-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20356",
    d: "M6 10a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm12 0a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2zm-6 0a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2z",
    className: "cls-2",
    transform: "translate(0 6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHoriz24Px);
export default __webpack_public_path__ + "static/media/more-horiz-24px.973a646329ef19da6d7e8acfc2feb1f4.svg";
export { ForwardRef as ReactComponent };